var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-pages-component-wrapper" },
    [
      _vm.field.readonly
        ? _c(_setup.FormControlPlainText, {
            attrs: { value: _setup.componentTitle, "form-id": _vm.formId },
          })
        : _setup.options
        ? _c(_setup.FormControlTypeSelect, {
            attrs: {
              "current-data": _vm.currentData,
              field: _vm.field,
              "form-id": _vm.formId,
              options: _setup.options,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }